/**
 * Created by toor on 19-03-05.
 */

export default function phoneNumFilter(input) {
  if (input !== undefined)
    return input.substring(0, 3) + "****" + input.substring(input.length - 4);
}



// WEBPACK FOOTER //
// ./src/modules/filter/phoneNumFilter.js